import { render, staticRenderFns } from "./PoReceipt.vue?vue&type=template&id=86aba084&scoped=true&"
import script from "./PoReceipt.vue?vue&type=script&lang=js&"
export * from "./PoReceipt.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "86aba084",
  null
  
)

export default component.exports